import apiClient from './apiClient';

export const projectApi = {
    getProjects: () => apiClient.get('/api/projects').then(res => res.data),
    getPermissions: () => apiClient.get('/api/projects/permissions').then(res => res.data),
    getAllStatus: () => apiClient.get('/api/projects?status=all').then(res => res.data),

    createProject: (data) => apiClient.post('/api/projects', data).then(res => res.data),
    updateProject: (id, data) => apiClient.put(`/api/projects/${id}`, data).then(res => res.data),
    updateProjectStatus: (id, status) => apiClient.put(`/api/projects/${id}/status`, { status }).then(res => res.data),
    deleteProject: (id, permanent = false) => apiClient.delete(`/api/projects/${id}${permanent ? '?permanent=true' : ''}`).then(res => res.data),
    restoreProject: (id) => apiClient.post(`/api/projects/${id}/restore`).then(res => res.data),

    bulkUpdateStatus: (ids, status) => apiClient.put('/api/projects/bulk-status', { ids, status }).then(res => res.data),
    bulkDelete: (ids, permanent = false) => apiClient.delete('/api/projects/bulk-delete', { data: { ids, permanent } }).then(res => res.data),
    getDeletedProjects: () => apiClient.get('/api/projects?status=deleted').then(res => res.data),

    getProjectUsers: (projectId) => apiClient.get(`/api/projects/${projectId}/users`).then(res => res.data),
    addProjectUser: (projectId, data) => apiClient.post(`/api/projects/${projectId}/users`, data).then(res => res.data),
    removeProjectUser: (projectId, userId) => apiClient.delete(`/api/projects/${projectId}/users/${userId}`).then(res => res.data),
    getProjectAnalysis: (projectId) => apiClient.get(`/api/projects/${projectId}/analysis`).then(res => res.data),
    getProjectAnalysisTimesheets: (projectId) => apiClient.get(`/api/projects/${projectId}/analysis/timesheets`).then(res => res.data),
    getProjectAnalysisAssignments: (projectId) => apiClient.get(`/api/projects/${projectId}/analysis/assignments`).then(res => res.data),
    getProjectAnalysisJournal: (projectId) => apiClient.get(`/api/projects/${projectId}/analysis/journal`).then(res => res.data),
};

